<div id="myContainer">
  <div myCdkOverlayContainer></div>
  <ng-container #container></ng-container>
  <div *ngIf="device === 'mobile' || device === 'tablet'" class="z-index-2">
    <app-footer-navbar></app-footer-navbar>
  </div>
</div>
